import { ActivatedRoute, Router } from '@angular/router';
import { IChildProject } from 'src/app/models/projects/project.model';
import { FlowType, IProofReading, Proofreading } from 'src/app/models/proofreading.model';
import { AlertService } from 'src/app/services/alert.service';
import { AuthService } from 'src/app/services/auth.service';
import { LivecoAPIService } from 'src/app/services/liveco-api.service';
import { LoaderService } from 'src/app/services/loader.service';
import { ViewComponent } from 'src/app/shared/pages/view/view.component';
import { environment } from 'src/environments/environment';
import _ from 'lodash';
import jQuery from "jquery";
import { StateMachineService } from 'src/app/services/machine-state.service';
import { ProofreadingService } from 'src/app/services/proofreading.service';
import { ProjectService } from 'src/app/services/project.service';
import { ExternStateName, ExternStatePayloadFlag, IState } from 'src/app/models/states.model';
import { DomSanitizer, Title } from '@angular/platform-browser';
import { BehaviorSubject } from 'rxjs';
import { ElementRef } from '@angular/core';
import { MembersService } from 'src/app/services/member.service';
import { MemberStatus, MemberPermission } from 'src/app/models/projects/submodels/members.model';
import { ProofreadingHistoryService } from 'src/app/services/proofreading-history.service';
import { TranslateService } from '@ngx-translate/core';
import { debounceTime } from 'rxjs/operators';
import { MarqueService } from 'src/app/services/marque.service';


export class AbstractSplitView extends ViewComponent {
    drawer: ElementRef;

    get MEMBER_STATUS() {
        return MemberStatus;
    }

    get view_links() {
        return this.s_proofreadings.view_links;
    }

    // protected _externViewLink: BehaviorSubject<string | null> = new BehaviorSubject<string | null>("");
    // protected _internViewLink: BehaviorSubject<string | null> = new BehaviorSubject<string | null>("");

    constructor(
        protected title: Title,
        protected route: ActivatedRoute,
        protected router: Router,
        protected s_alert: AlertService,
        protected s_loader: LoaderService,
        protected s_auth: AuthService,
        protected liveco: LivecoAPIService,
        protected s_sm: StateMachineService,
        protected s_proofreadings: ProofreadingService,
        protected s_projects: ProjectService,
        protected s_members: MembersService,
        protected sanitizer: DomSanitizer,
        protected s_marques: MarqueService,
    ) {
        super(route, router, s_alert, s_loader, s_auth);
        this.s_proofreadings.syncRT('enable');
        this.subscription.add(this.s_proofreadings.current$.pipe(debounceTime(200)).subscribe(this.onDataRecieved.bind(this)));
        this.subscription.add(document.addEventListener('exit-fullscreen', this.cancelFullScreen.bind(this)));
    }

    // Project related getters
    get project(): IChildProject | undefined {
        return this.s_projects.current as any;
    }
    get identifier(): string {
        return this.project?.identifier || '';
    };
    get description(): string {
        return this.project?.description || '';
    };

    get current_member() {
        return this.s_members.current_member;
    };

    // PR related getters 
    get proofreading(): Proofreading | undefined {
        return this.s_proofreadings.current;
    }
    get flow(): FlowType {
        return this.proofreading?.flow || FlowType.EXE;
    }

    // EXTERN
    private _url: string | null = null;
    get url() {
        if(this._url) return this._url;
        return this.proofreading?.view_url;
    }
    private _url_readonly: string | null = null;
    get url_readonly() {
        if(this._url_readonly) return this._url_readonly;
        return this.proofreading?.view_url_readonly;
    }


    get externState(): IState | undefined {
        return this.proofreading?.state;
    }
    get current_relecture() {
        return this.proofreading?.relecture || 1;
    }

    // TEXTES RELECTURE
    get has_textes_flow() {
        return this.flow === FlowType.EXE || this.flow === FlowType.EZD_EXE;
    }

    // INTERN
    get url_intern() {
        return this.proofreading?.intern?.viewer.url;
    }
    // url_intern: string | null = null;

    get internState(): IState | undefined {
        return this.proofreading?.intern?.currentState;
    }
    get current_version() {
        return this.proofreading?.intern?.viewer.version;
    }

    // VIEW
    opened: boolean = true;

    get view_link_url() {
        if (this.readOnlyProofscope) {
            return environment.cfURL + this.url_readonly;
        }
        return environment.cfURL + this.url;
        // return this.sanitizer.bypassSecurityTrustResourceUrl(environment.cfURL + this.url);
    }
    get intern_view_link_url() {
        if (this.isClient()) {
            return '';
        }
        return environment.cfURL + this.url_intern;
        // return this.sanitizer.bypassSecurityTrustResourceUrl(environment.cfURL + this.url_intern);
    }



    //#region PERMISSION
    /**
     * Does the current state allow the user to edit
     */
    get locked() {
        return this.isClient() && !this.s_sm.hasPayloadFlag(ExternStatePayloadFlag.CUSTOMER_CAN_EDIT, (this.externState?.slug || ExternStateName.INIT) as ExternStateName, this.flow, 'extern');
    }

    get cantReadText() {
        // Only clients are restricted
        return this.isClient() && !this.s_members.hasPermission([MemberPermission.TEXT_READ], '&');
    }

    get cantReadProofscope() {
        // Only clients are restricted
        return false;  //this.isClient() && !this.s_members.hasPermission([MemberPermission.PROOFSCOPE_READ], '&');
    }

    get readOnlyProofscope() {
        return this.locked
            // Only clients are restricted
            || (this.isClient() && !this.s_members.hasPermission([MemberPermission.PROOFSCOPE_WRITE], '&'));
    }
    get readOnlyText(): boolean {
        return this.locked
            // Only clients are restricted
            || (this.isClient() && (!this.s_members.hasPermission([MemberPermission.TEXT_WRITE], '&') || this.s_members.hasStatus([MemberStatus.READ_ONLY], '&')))
            || this.isOperator(); // deny editing if operator
    };
    //#endregion

    async retrieveData() {
        await super.retrieveData();
        if (this.id) {
            try {
                // GET CURRENT PR FROM ID
                await this.s_proofreadings.getCurrent(this.id);
            } catch (err) {
                console.error(err);
                this.router.navigate(['error', '404'], { queryParams: { message: 'PROOFREADING_MISSING' } });
            }
        }
    }

    // rename it to onDataRecieved after view refacto is over
    protected async onDataRecieved(current: IProofReading | undefined) {
        if (!current) {
            return;
        }
        await this.s_projects.getCurrent(current.project.ID);
        const marqueLabel = this.project?.custom?.general_info?.marque;
        const marques = await this.s_marques.find({ label: marqueLabel});
        // If marques contains more than one entry, select the one whose label matches
        this.s_marques.current = _.find(marques, { label: marqueLabel }) || marques[0] || undefined;
        await this.s_proofreadings.find({ 'project.ID': current.project.ID });

        await this.s_proofreadings.updateHistory();
        await this.manageIFrame();

        // SET TITLE
        this.title.setTitle(`${this.identifier} - ${this.description}`);
    }


    async manageIFrame() {
        // fetch view url on demand
        if (this.currentUser?.isDiadem) {
            this.manageIFrameForDiadem();
        } else {
            await this.manageIFrameForExternals();
        }

    }

    private async manageIFrameForExternals() {
        
        // const urls = await Promise.all([this.s_proofreadings.getViewUrl('extern'), this.s_proofreadings.getViewUrl('intern')])
        // const extern = urls[0];
        // const intern = urls[1];
        const extern = await this.s_proofreadings.getViewUrl('extern');
        this._url = extern.view_url;
        this._url_readonly = extern.view_url_readonly;

        // Set the view link this proofscope url
        if (this.view_links.extern.value?.toString() !== this.view_link_url.toString()
            || jQuery("#externViewLink").attr("src") !== this.view_link_url.toString()) {
            this.view_links.extern.next(this.view_link_url.toString());
            if (this.view_links.extern.value !== environment.cfURL) {
                jQuery("#externViewLink").attr("src", this.view_links.extern.value);
            } else {
                jQuery("#externViewLink").attr("src", "");
            }
        }

        // // Set the view link this proofscope url intern
        // if (this.view_links.intern.value?.toString() !== this.intern_view_link_url.toString()
        //     || jQuery("#internViewLink").attr("src") !== this.view_link_url.toString()) {
        //     this.view_links.intern.next(this.intern_view_link_url.toString());

        //     if (this.view_links.intern.value !== environment.cfURL) {
        //         jQuery("#internViewLink").attr("src", this.view_links.intern.value);
        //     } else {
        //         jQuery("#internViewLink").attr("src", "");
        //     }
        // }
    }

    private manageIFrameForDiadem() {

        // Set the view link this proofscope url
        if (this.view_links.extern.value?.toString() !== this.view_link_url.toString()
            || jQuery("#externViewLink").attr("src") !== this.view_link_url.toString()) {
            this.view_links.extern.next(this.view_link_url.toString());

            if (this.view_links.extern.value !== environment.cfURL) {
                jQuery("#externViewLink").attr("src", this.view_links.extern.value);
            } else {
                jQuery("#externViewLink").attr("src", "");
            }
        }

        // Set the view link this proofscope url intern
        if (this.view_links.intern.value?.toString() !== this.intern_view_link_url.toString()
            || jQuery("#internViewLink").attr("src") !== this.view_link_url.toString()) {
            this.view_links.intern.next(this.intern_view_link_url.toString());

            if (this.view_links.intern.value !== environment.cfURL) {
                jQuery("#internViewLink").attr("src", this.view_links.intern.value);
            } else {
                jQuery("#internViewLink").attr("src", "");
            }
        }
    }


    cancelFullScreen() {
        const iframe = document.getElementsByTagName('iframe')[0] as HTMLIFrameElement;
        iframe.parentElement?.classList.remove('splitview-fullscreen');
    }

    // Magalie t'es forte j'ai galere a comprendre comment tu passais d'une url proofscope a un file_url ><'
    // proofscopeUrlToUrl(proofscopeUrl: any): string {
    //     console.log('PR URL', proofscopeUrl);
    //     const regex = /\&url\=(.+)\.pdf/;
    //     let url = !_.isNull(proofscopeUrl.match(regex)) ? proofscopeUrl.match(regex)[1] + '.pdf' : proofscopeUrl;
    //     url = decodeURIComponent(url);
    //     return url;
    // }
}
